import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const key = ({ serviceId, houseId }) => [
  'getCheckWarranty',
  serviceId,
  houseId,
];

export const getCheckWarranty = async ({ serviceId, houseId }) => {
  return await request.get(
    '/Request/check_warranty',
    { serviceId, houseId },
    'При проверки причины произошла ошибка'
  );
};

const useCheckWarranty = ({ serviceId, houseId }, options) =>
  useQuery(
    key({ serviceId, houseId }),
    () => getCheckWarranty({ serviceId, houseId }),
    options
  );

export default useCheckWarranty;
